import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(() => ({
  botTypingBubble: {
    display: 'flex',
    gap: 6,
    backgroundColor: '#f0f0f0',
    padding: '12px 16px',
    borderRadius: 16,
    width: 48,
    justifyContent: 'center',
  },

  dot: {
    width: 8,
    height: 8,
    backgroundColor: '#555',
    borderRadius: '50%',
    animation: '$bounce 1.4s infinite ease-in-out both',
    '&:nth-of-type(2)': {
      animationDelay: '0.2s',
    },
    '&:nth-of-type(3)': {
      animationDelay: '0.4s',
    },
  },

  '@keyframes bounce': {
    '0%, 80%, 100%': {
      transform: 'scale(0)',
    },
    '40%': {
      transform: 'scale(1)',
    },
  },
}))

const BotTypingIndicator = () => {
  const classes = useStyles()
  return (
    <div className={classes.botTypingBubble}>
      <span className={classes.dot} />
      <span className={classes.dot} />
      <span className={classes.dot} />
    </div>
  )
}

export default BotTypingIndicator
